export const MAX_ITEMS_ON_DISPLAY = 6;
export const ELEMENT_HEIGHT_DEFAULT = 36;
